// Tag chips and filtering for the projects page. Pure functions over the
// site's own project data.

// Every tag with how many projects use it: most used first, then A to Z.
export function collectTags(projects) {
    const counts = new Map();
    projects.forEach((project) => {
        new Set(project.tags || []).forEach((tag) => counts.set(tag, (counts.get(tag) || 0) + 1));
    });
    return [...counts.entries()]
        .map(([tag, count]) => ({ tag, count }))
        .sort((a, b) => b.count - a.count || a.tag.localeCompare(b.tag));
}

// Text search (name, description, tags) combined with an optional exact tag.
export function filterProjects(projects, search = '', tag = '') {
    const query = search.trim().toLowerCase();
    return projects.filter((project) => {
        if (tag && !(project.tags || []).includes(tag)) return false;
        const content = [project.projectName, project.projectDesc, ...(project.tags || [])].join(' ');
        return content.toLowerCase().includes(query);
    });
}
